/* Cornea Digital Podium landing page. Vanilla JS, no dependencies.
   Motion is progressive: without JS or with prefers-reduced-motion, all content is simply visible. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 1024px)');
  var live = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  var PAGE = 'electric-digital-podium';

  function track(name, params) {
    var p = Object.assign({ lp: PAGE }, params || {});
    if (live && typeof window.gtag === 'function') window.gtag('event', name, p);
    else if (window.console) console.info('[lp-track preview]', name, p);
  }

  /* ---------- Request a Quote: links go to the Zoho enquiry form exactly as set in lp-cta; clicks are tracked ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lp-cta]');
    if (!a) return;
    track('cta_click', { cta_id: a.getAttribute('data-cta') });
    track('quote_start', { cta_id: a.getAttribute('data-cta') });
  });

  /* ---------- Scroll reveals ---------- */
  var revealEls = document.querySelectorAll('.lp [data-reveal], .lp [data-anim]');
  if (!reduce && 'IntersectionObserver' in window) {
    doc.classList.add('lp-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92) el.classList.add('is-in'); /* already on screen: never hide it */
      else io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Count-up for key facts (leading number only; final text is in the HTML) ---------- */
  function countUp(el) {
    var full = el.textContent;
    var m = full.match(/^(\d+(?:\.\d+)?)/);
    if (!m) return;
    var end = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length, rest = full.slice(m[1].length), t0 = performance.now();
    el.setAttribute('aria-label', full);
    (function step(now) {
      var p = Math.min(1, (now - t0) / 800), e = 1 - Math.pow(1 - p, 3);
      el.textContent = (end * e).toFixed(dec) + rest;
      if (p < 1) requestAnimationFrame(step); else { el.textContent = full; el.removeAttribute('aria-label'); }
    })(t0);
  }
  if (!reduce && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); } });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-lp-count]').forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Offset for the sticky showcase: only a header bar that actually stays on screen counts ---------- */
  function headerOffset() {
    var h = document.querySelector('#shopify-section-header');
    var bottom = 0;
    if (h) h.querySelectorAll('*').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.width && r.height < 200 && r.left < innerWidth && r.bottom > 0) bottom = Math.max(bottom, r.bottom);
    });
    doc.style.setProperty('--lp-sticky-top', Math.round(bottom + 24) + 'px');
  }
  headerOffset();

  /* ---------- Interactive showcase ---------- */
  var show = document.querySelector('[data-lp-showcase]');
  var steps = show ? show.querySelectorAll('[data-lp-step]') : [];
  var spots = show ? show.querySelectorAll('[data-lp-hotspot]') : [];
  var views = show ? show.querySelectorAll('.lp-show__view') : [];
  var current = -1;
  /* A view without its own image falls back to the front image */
  function viewOf(el) {
    var v = (el && el.getAttribute('data-view')) || 'front';
    return show.querySelector('.lp-view-' + v) ? v : 'front';
  }
  function setStep(i) {
    if (!show || i === current) return;
    current = i;
    var view = viewOf(steps[i]);
    steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    /* Hotspots are positioned on one photo, so only those for the photo on screen are shown */
    spots.forEach(function (s) {
      s.classList.toggle('is-active', +s.getAttribute('data-lp-hotspot') === i);
      s.classList.toggle('is-off', viewOf(s) !== view);
    });
    var target = show.querySelector('.lp-view-' + view);
    views.forEach(function (v) { v.classList.toggle('is-current', v === target); });
  }
  if (show) {
    setStep(0);
    spots.forEach(function (b) {
      b.addEventListener('click', function () { setStep(+b.getAttribute('data-lp-hotspot')); track('hotspot_click', { hotspot: b.getAttribute('aria-label') }); });
    });
    steps.forEach(function (s, k) {
      s.addEventListener('click', function () { setStep(k); });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setStep(k); } });
    });
  }
  function updateShowcase() {
    if (!show || !desktop.matches || reduce) return;
    var trackEl = show.querySelector('.lp-show__track');
    var r = trackEl.getBoundingClientRect();
    var span = r.height - innerHeight;
    if (span <= 0) return;
    var p = Math.min(1, Math.max(0, -r.top / span));
    show.style.setProperty('--lp-p', p.toFixed(3));
    setStep(Math.min(steps.length - 1, Math.floor(p * steps.length * 0.999)));
  }

  /* ---------- Hero parallax (desktop only) ---------- */
  var par = document.querySelector('[data-lp-parallax]');
  function updateParallax() {
    if (!par || !desktop.matches || reduce) { if (par) par.style.transform = ''; return; }
    var y = Math.min(window.scrollY, 700);
    par.style.transform = 'translate3d(0,' + (y * 0.08).toFixed(1) + 'px,0)';
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; updateParallax(); updateShowcase(); });
  }
  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { headerOffset(); onScroll(); }, { passive: true });
    onScroll();
  }

  /* ---------- Product video: poster first; muted autoplay in view (if enabled) or play on click ---------- */
  var frame = document.querySelector('[data-lp-video]');
  var videoEl = null;
  function mountVideo(autoplayMuted) {
    if (videoEl || !frame) return videoEl;
    var tpl = frame.querySelector('[data-lp-video-template]');
    if (!tpl) return null;
    frame.appendChild(tpl.content.cloneNode(true));
    videoEl = frame.querySelector('video');
    if (!videoEl) return null;
    videoEl.setAttribute('playsinline', '');
    var sent = {};
    videoEl.addEventListener('play', function () { if (!sent.play) { sent.play = 1; track('video_play', {}); } });
    videoEl.addEventListener('timeupdate', function () {
      var d = videoEl.duration || 0, t = videoEl.currentTime;
      [25, 50, 75].forEach(function (q) { if (d && t / d * 100 >= q && !sent[q]) { sent[q] = 1; track('video_progress', { percent: q }); } });
      document.querySelectorAll('[data-lp-seek]').forEach(function (b) {
        var li = b.closest('.lp-chapter'), start = +b.getAttribute('data-lp-seek');
        var next = li.nextElementSibling && li.nextElementSibling.querySelector('[data-lp-seek]');
        var end = next ? +next.getAttribute('data-lp-seek') : Infinity;
        li.classList.toggle('is-current', t >= start && t < end);
      });
    });
    if (autoplayMuted) { videoEl.muted = true; videoEl.defaultMuted = true; videoEl.loop = true; videoEl.controls = false; }
    return videoEl;
  }
  if (frame) {
    var poster = frame.querySelector('[data-lp-play]');
    var soundBtn = frame.querySelector('[data-lp-sound]');
    var previewing = false;
    /* Full playback: sound on, controls on, optionally from a chapter start */
    var playWithSound = function (t) {
      var v = mountVideo(false);
      if (!v) return;
      previewing = false;
      frame.classList.remove('is-preview');
      if (soundBtn) soundBtn.hidden = true;
      if (poster && poster.parentNode) poster.remove();
      v.muted = false; v.controls = true; v.loop = false;
      var go = function () { if (t !== undefined) v.currentTime = t; v.play().catch(function () {}); };
      if (v.readyState >= 1) go(); else v.addEventListener('loadedmetadata', go, { once: true });
      v.focus({ preventScroll: true });
    };
    if (poster) poster.addEventListener('click', function () { playWithSound(previewing ? 0 : undefined); });
    if (soundBtn) soundBtn.addEventListener('click', function () { playWithSound(0); track('video_sound_on', {}); });
    document.querySelectorAll('[data-lp-seek]').forEach(function (b) {
      b.addEventListener('click', function () { playWithSound(+b.getAttribute('data-lp-seek')); });
    });
    var saveData = navigator.connection && navigator.connection.saveData;
    if (frame.hasAttribute('data-autoplay-preview') && !reduce && !saveData && 'IntersectionObserver' in window) {
      var startPreview = function () {
        var v = mountVideo(true);
        if (!v) return;
        previewing = true;
        v.addEventListener('click', function () { if (previewing) playWithSound(0); });
        v.play().then(function () {
          frame.classList.add('is-preview');
          if (soundBtn) soundBtn.hidden = false;
        }).catch(function () { previewing = false; v.remove(); videoEl = null; });   /* autoplay blocked: drop it so the poster works as a normal play button */
      };
      /* Wait for the page to finish loading so the video never competes with the hero */
      var observe = function () {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              if (!videoEl) startPreview();
              else if (previewing && videoEl.paused) videoEl.play().catch(function () {});
            } else if (previewing && videoEl && !videoEl.paused) {
              videoEl.pause();   /* out of view: stop using bandwidth and CPU */
            }
          });
        }, { threshold: 0.35 }).observe(frame);
      };
      if (document.readyState === 'complete') observe(); else window.addEventListener('load', observe, { once: true });
    }
  }

  /* ---------- Mobile sticky Request a Quote ---------- */
  var bar = document.querySelector('[data-lp-sticky]');
  var hero = document.querySelector('.lp-hero');
  var finalSec = document.querySelector('[data-lp-final]');
  if (bar && 'IntersectionObserver' in window) {
    var pastHero = false, atFinal = false;
    var upd = function () { bar.hidden = !(pastHero && !atFinal); };
    if (hero) new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; upd(); }).observe(hero);
    if (finalSec) new IntersectionObserver(function (e) { atFinal = e[0].isIntersecting; upd(); }).observe(finalSec);
  }
})();
